import styled from 'styled-components'

export const Flex = styled.div`
  display: flex;
  height: ${props => props.fullHeight ? '100%' : 'auto'};
  width: ${props => props.fullWidth ? '100%' : 'auto'};
`

export const FlexCentered = styled(Flex)`
  align-items: center;
`

export const ColumnFlex = styled(Flex)`
  flex-direction: column;
`

export const ColumnFlexCentered = styled(ColumnFlex)`
  align-items: center;
`
